import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class BlogAPI {
	// Categories
	async getCategories() {
		return xget<{ categories: PGSchema.blog_categories[] }>("/blog/categories");
	}

	async createCategory(i18n: any) {
		return xhttp<{ category: PGSchema.blog_categories }>("/blog/categories", "POST", { i18n });
	}

	async updateCategory(id: number, i18n: any) {
		return xhttp<{ category: PGSchema.blog_categories }>(`/blog/categories/${id}`, "PUT", { i18n });
	}

	async deleteCategory(id: number) {
		return xhttp(`/blog/categories/${id}`, "DELETE");
	}

	// Blogs
	async getBlogs() {
		return xget<{ blogs: PGSchema.blog[]; categories: PGSchema.blog_categories[] }>("/blog");
	}

	async getBlog(id: number) {
		return xget<{ blog: PGSchema.blog; category: PGSchema.blog_categories }>(`/blog/${id}`);
	}

	async createBlog(blog: Partial<PGSchema.blog>) {
		return xhttp<PGSchema.blog>("/blog", "POST", blog);
	}

	async updateBlog(id: number, blog: Partial<PGSchema.blog>) {
		return xhttp<PGSchema.blog>(`/blog/${id}`, "PUT", blog);
	}

	async deleteBlog(id: number) {
		return xhttp(`/blog/${id}`, "DELETE");
	}
}
